var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-table',{ref:"customTable",attrs:{"columns":_vm.columns,"custom-view":_vm.customView,"footer-actions":_vm.footerActions,"sums":_vm.sums,"is-page-show":false,"api-url":"/pos-order-online-list","api-download-url":"/pos-order-online-export","download-file-name":"don-hang-pos.xlsx"},on:{"orderCancel":_vm.orderCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }